<template>
    <div>
        <div class="my-1">
            <label class="form-label">{{styleType}} Button</label>
        </div>

        <div class="mb-1 d-flex align-items-center" style="position: static;">
            <div class="me-2">BG</div>
            <color-picker :color-object="button" color-field="background_color" class="mt-1" @colorSelected="onBackgroundSelected"></color-picker>

            <div class="mx-2">Hover BG</div>
            <color-picker :color-object="button" color-field="hover_color" class="mt-1" @colorSelected="onHoverBgSelected"></color-picker>

            <div class="mx-2">Text</div>
            <color-picker :color-object="button" color-field="color" class="mt-1" @colorSelected="onTextSelected"></color-picker>
        </div>

        <div class="mb-1 d-flex align-items-center" style="position: static;">
            <div class="me-2">Border</div>
            <color-picker :color-object="button" color-field="border_color" class="mt-1" @colorSelected="onBorderSelected"></color-picker>

            <div class="mx-2">Hover Border</div>
            <color-picker :color-object="button" color-field="hover_border_color" class="mt-1" @colorSelected="onHoverBprderSelected"></color-picker>
        </div>

        <div class="mb-1 d-flex align-items-center">
            <label class="ms-2">Style</label>

            <select class="form-select form-control-sm w-50-pct ms-2" v-model="button.style" @change="onStyleSelected">
                <option>rounded</option>
                <option>square</option>
                <option>pill</option>
                <option>hand-drawn</option>
            </select>
        </div>

        <div class="mb-1 d-flex align-items-center">
            <input type="checkbox" id="checkbox" v-model="button.include_hover_effect" class="form-check-input" @change="refresh">
            <label for="checkbox" class="ms-2">Hover Effect</label>

            <select v-if="button.include_hover_effect" class="form-select form-control-sm w-50-pct ms-2" v-model="button.hover_effect">
                <option>float</option>
                <option>bulge</option>
            </select>
        </div>

    </div>
</template>

<script>
import ColorPicker from "../components/ColorPicker.vue";
export default {
    name: 'ButtonStyleEditor',
    components: {ColorPicker},
    props: ['button', 'styleType'],
    data () {
        return {
            model: webase.model
        }
    },
    methods: {
        onStyleSelected() {
            // if(this.button.style === 'hand-drawn') {
            //     console.log('ButtonStyleEditor, refreshing theme: ' + this.styleType)
            //     this.$emit('refreshTheme');
            // }
            this.$emit('refreshTheme');
        },
        onBackgroundSelected(color) {
            this.button.background_color = color
            this.$emit('refreshTheme');
        },
        onTextSelected(color) {
            this.button.color = color
            this.$emit('refreshTheme');
        },
        onBorderSelected(color) {
            this.button.border_color = color
            this.$emit('refreshTheme');
        },
        onHoverBgSelected(color) {
            this.button.hover_color = color
            this.$emit('refreshTheme');
        },
        onHoverBprderSelected(color) {
            this.button.hover_border_color = color
            this.$emit('refreshTheme');
        },
        refresh() {
            this.$emit('refreshTheme');
        }
    }
}
</script>

<style>

</style>
